import React, { useEffect, useState } from 'react';
import { Grid, Typography, Box, Select, MenuItem, FormControl, Dialog, useMediaQuery } from '@mui/material';
import { PaySystemBox } from '../../libs/theme';
import REST from '../../libs/API';
import PaySystemList from '../main/PaySystemList';
import OrderFormFields from '../main/OrderFormFields';
import PSIcon from '../../components/PSIcon';
import { getText } from '../../libs/utils';
import { useTheme } from '@mui/material/styles';
import { ArrowDown } from '../../assets/images/icons';

const RefsPayout = ({ systems = [], userToken, currencyAmounts }) => {
  const theme = useTheme();
  let isXS = useMediaQuery(theme.breakpoints.only('xs'));
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [activeSystem, setActiveSystem] = useState(systems[0]);
  const [activeCurrency, setActiveCurrency] = useState(systems[0].currencies[0]);
  const [formData, setFormData] = useState({});
  const [formFields, setFormFields] = useState({});

  useEffect(() => {
    getFormData();
  }, [activeCurrency]);

  const getFormData = () => {
    REST.getRefWithdrawForm(userToken, activeSystem.id, activeCurrency.id).then((data) => {
      setFormFields(data);
    });
  }

  const handleSelectCurrency = (event) => {
    const currencyId = event.target.value;
    setActiveCurrency(activeSystem.currencies.find((item) => item.id === currencyId));
  }

  const handleSubmitForm = () => {
    setLoading(true);
    REST.sendWithdrawReq(userToken, activeSystem.id, activeCurrency.id, formData)
      .then(data => {
        if (!data.success) {
          window.showMessage(data.data[0].message, { variant: "warning" });
        } else {
          window.showMessage(getText("accRefWithdrawalSuccess"));
        }
        setLoading(false);
      })
  }

  const selectSystemField = <Box className="form-field"
    sx={{
      display: 'grid',
      gap: '10px',
      gridTemplateColumns: '1fr auto',
    }}
  >
    <PaySystemBox onClick={() => setOpenDialog(true)} sx={{ cursor: 'pointer' }}>
      <Box sx={{ flex: 1, display: 'flex', alignItems: 'center' }} onClick={() => setOpenDialog(true)}>
        <PSIcon
          name={activeSystem.className}
          height={24}
          width={24}
          margin="0 10px 0 0"
        />
        <Box sx={{ width: '100%' }}>
          {activeSystem.name}
        </Box>
        <ArrowDown style={{
          width: 21,
        }} />
      </Box>
    </PaySystemBox>

    <FormControl size="small" >
      <PaySystemBox>
        <Select
          value={activeCurrency.id}
          onChange={handleSelectCurrency}
          disabled={activeSystem.currencies.length <= 1 ? true : false}
          MenuProps={{
            PaperProps: {
              variant: "small",
            },
          }}
        >
          {activeSystem.currencies.map((item, key) => (
            <MenuItem
              key={key}
              value={item.id}
              sx={{ display: activeCurrency.id === item.id ? 'none' : 'inherit' }}
            >
              {item.network || item.name}
            </MenuItem>
          ))}
        </Select>
      </PaySystemBox>
    </FormControl>

  </Box>;

  let submitButtonText = getText('accRefWithdrawalBtn');
  let isNotEnough = formFields?.amount?.value * 1 < activeCurrency.minAmount * 1;
  
  if (isNotEnough) {
    submitButtonText = `${getText("refPayMinAmount")}: ${activeCurrency.minAmount} ${activeCurrency.code}`;
  }

  return (
    <>
      {systems.length > 0 ? <>
        {formFields?.inputs &&
          <OrderFormFields
            className="refs-payout"
            additionalField={selectSystemField}
            fields={formFields.inputs}
            notices={[formFields.toNotice]}
            handleSubmitOrder={handleSubmitForm}
            formData={formData}
            setFormData={setFormData}
            iAgree={false}
            button={submitButtonText}
            buttonSx={isNotEnough ? { fontSize: 14, fontWeight: 600, textTransform: 'initial' } : {}}
            loading={isNotEnough || loading}
            systemsType={{ from: "disabled", to: "disabled" }}
            buttonLeftCol={
              <Box sx={{ display: 'flex', gap: '30px', padding: ['5px 0 0', 0] }}>
                <Box>
                  <Typography variant="boldRegCaption" component="div">{`${currencyAmounts.amount} ${currencyAmounts.name}`}</Typography>
                  <Typography variant="greyCaption">{getText('accRefLabel')}</Typography>
                </Box>
                <Box>
                  <Typography variant="boldRegCaption" component="div">{`${formFields.amount.value} ${formFields.amount.currencyCode}`}</Typography>
                  <Typography variant="greyCaption">{getText('accRefWithdrawal')}</Typography>
                </Box>
              </Box>
            }
          />}
      </>
        : <></>
      }

      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        maxWidth="md"
      >
        <PaySystemList
          title={getText('accReqChoosePs')}
          list={systems}
          onClose={() => setOpenDialog(false)}
          activeSystem={activeSystem}
          setSystem={setActiveSystem}
          setCurrency={setActiveCurrency}
          showFilter={false}
          grid={isXS ? 2 : 3}
        />
      </Dialog>
    </>
  )
}

export default RefsPayout